import React, { FunctionComponent } from 'react';
import classnames from 'classnames';
import { RecommendRecruitment } from '../../../types/recruitments';

type Props = {
  isShowCompanyInfo: boolean;
  isModalOpen: boolean;
  recommendRecruitments: RecommendRecruitment[];
  handleModalClose: () => void;
};

export const Presentation: FunctionComponent<Props> = ({ isShowCompanyInfo, isModalOpen, recommendRecruitments, handleModalClose }) => {
  return (
    <>
      <div className={classnames('common__modal', 'gtm-popup-view-count', { active: isModalOpen })} data-event-name='popup on screen' data-category='lp_popup' data-value='popup'>
        <div className="common__modal__wrapper">
          <h3 className="common__modal__title">
            <div onClick={handleModalClose} className="mask">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M0.735395 12L0 11.2646L5.26461 6L0 0.735394L0.735395 0L6 5.26461L11.2646 0L12 0.735394L6.7354 6L12 11.2646L11.2646 12L6 6.73539L0.735395 12Z" fill="#19190F"/>
              </svg>
            </div>
            <p className="title">おすすめの求人</p>
          </h3>

          <div className="common__modal__inner common__modal__inner--no-footer">
            <div className="common__modal__inner__list">
              {recommendRecruitments?.map((recruitment) => (
                <a
                  key={recruitment.id}
                  href={`/recruitments/${recruitment.id}`}
                  className="common__modal__inner__link"
                  data-event='click'
                  data-category='lp_popup'
                  data-value={isShowCompanyInfo ? 'panel' : 'panel_noimage'}
                  data-recruitmentid={recruitment.id}
                  data-companyid={recruitment.companyId}
                >
                  <div className="common__modal__inner__item">
                    <div className="common__modal__inner__image">
                      <img src={recruitment.imageUrl} alt={recruitment.title} />
                    </div>
                    <div className="common__modal__inner__content">
                      <p className="common__modal__inner__item-title">{recruitment.title}</p>
                      <div className="common__modal__inner__meta">
                        <span>{recruitment.occupation}</span>
                        <span>{recruitment.prefecture}</span>
                      </div>
                      {isShowCompanyInfo && (
                        <div className="common__modal__inner__company">
                          <img src={recruitment.companyLogo} alt={recruitment.companyName} />
                          <span className="name">{recruitment.companyName}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div onClick={handleModalClose} className={classnames('common__modal--bg', { active: isModalOpen })}></div>
    </>
  );
};
